import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Products } from "@/components/Products";
import { CandleOrder } from "@/components/CandleOrder";
import { HowItWorks } from "@/components/HowItWorks";
import { Guidance } from "@/components/Guidance";
import { Reviews } from "@/components/Reviews";
import { About } from "@/components/About";
import { LocationSection } from "@/components/LocationSection";
import { Social } from "@/components/Social";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { MobileNav } from "@/components/MobileNav";
import { CookieNotice } from "@/components/CookieNotice";
import { Legal } from "@/components/Legal";

const Home = () => (
    <main>
        <Hero />
        <Services />
        <Products />
        <CandleOrder />
        <HowItWorks />
        <Guidance />
        <Reviews />
        <About />
        <LocationSection />
        <Social />
    </main>
);

function App() {
    return (
        <LanguageProvider>
            <BrowserRouter>
                <div className="App bg-ink text-cream font-body">
                    <div className="noise-overlay" aria-hidden="true" />
                    <Navbar />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/privacidad" element={<Legal kind="privacy" />} />
                        <Route path="/terminos" element={<Legal kind="terms" />} />
                    </Routes>
                    <Footer />
                    <FloatingWhatsApp />
                    <MobileNav />
                    <CookieNotice />
                    <Toaster
                        theme="dark"
                        position="top-center"
                        toastOptions={{
                            style: {
                                background: "#1a161d",
                                border: "1px solid rgba(212,175,55,0.35)",
                                color: "#f4f0e6",
                            },
                        }}
                    />
                </div>
            </BrowserRouter>
        </LanguageProvider>
    );
}

export default App;
